<template>
  <BaseCard noPadding class="tw:w-full" data-testid="rc-plus-cross-sell-banner">
    <RateConnectPlusCrossSellOfferContent
      :is-price-fetching="isPriceFetching"
      :discounted-monthly-price="discountedMonthlyPrice"
      :monthly-price="monthlyPrice"
      :total-price-before-taxes="totalPriceBeforeTaxes"
      :base-subscription-full-term-price="baseSubscriptionFullTermPrice">
      <template #heading>
        <h2 class="tw:text-xl tw:font-bold tw:mb-1">{{ $t('rc_plus_upsell_header') }}</h2>
      </template>
    </RateConnectPlusCrossSellOfferContent>
    <div
      class="tw:p-6 tw:flex tw:flex-col tw:md:flex-row tw:flex-col-reverse tw:justify-between tw:items-center tw:gap-y-4 tw:border-t tw:border-gray-300">
      <p class="tw:text-sm tw:text-gray-600 tw:self-start tw:md:self-auto">{{ $t('rc_plus_upsell_footnote') }}</p>
      <MainButton
        class="tw:w-full tw:md:w-auto"
        :data-testid="
          plusUpsellSubscribeAction === 'login-as-admin'
            ? 'rc-plus-cross-sell-login-as-admin-cta'
            : 'rc-plus-cross-sell-continue-cta'
        "
        @click="$emit('continue')">
        {{ plusUpsellSubscribeAction === 'login-as-admin' ? $t('rc_admin_log_in_cta') : $t('setup_next') }}
      </MainButton>
    </div>
  </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from '@/components/dashboard/BaseCard.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import RateConnectPlusCrossSellOfferContent from '@/components/rateConnect/studioPlusCrossSell/RateConnectPlusCrossSellOfferContent.vue'
import type { PlusUpsellSubscribeAction } from '@/composables/useRcPlusCrossSell'

interface Props {
  isPriceFetching: boolean
  discountedMonthlyPrice: number
  monthlyPrice: number
  totalPriceBeforeTaxes: number
  baseSubscriptionFullTermPrice: number
  plusUpsellSubscribeAction: PlusUpsellSubscribeAction
}

defineProps<Props>()

defineEmits<{
  continue: []
}>()
</script>
